import React, { Component } from 'react'
import { formatNumber, formatUnit } from 'utils'
import isNil from 'lodash/isNil'
import defaultTo from 'lodash/defaultTo'

export interface ITableData {
  name: string
  col: number
  text?: string | number
  unit?: string
  leftAlign?: boolean
  highlight?: boolean
  underline?: boolean
  borderBottom?: boolean
  className?: string
  hideUnit?: boolean
  onClick?: () => void
}

class TableData extends Component<ITableData, {}> {
  getText = () => {
    const { unit, text, hideUnit } = this.props

    if (!isNil(unit) && !isNil(text)) {
      if (hideUnit) {
        return `${formatNumber(String(text), unit)}`
      }
      return `${formatNumber(String(text), unit)} ${formatUnit(unit)}`
    }
    return text
  }

  public render() {
    const {
      name,
      col,
      leftAlign,
      highlight,
      underline,
      onClick,
      borderBottom,
      className,
    } = this.props

    return (
      <div
        className={`flex w-${col}/12 ${
          leftAlign ? 'text-left' : 'text-right'
        } items-center first-child:text-left ${defaultTo(className, '')}`}
      >
        <div
          onClick={() => {
            if (onClick) onClick()
          }}
          key={name}
          className={`h-full w-full relative py-10 ${
            underline ? 'ml-30 border-black' : 'border-gray-200'
          } ${borderBottom ? 'border-b-0' : 'border-b-1'}`}
        >
          <div className="h-full flex items-center">
            <p
              className={`w-full ${
                highlight ? 'text-brand-primary cursor-pointer' : 'text-black'
              } text-13 font-400 tracking-0.1`}
            >
              {this.getText()}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default TableData
